/** Sentinel in groupedColumns to mark the leaf/data level for breakdown insert order. */
export const LEAF_LEVEL_SENTINEL = '__leaf__'

/** Value shown in group rows for non-aggregate, non-group columns (e.g. status fields). */
export const GROUP_ROW_PLACEHOLDER = '-'

/**
 * Response key for the group-row leaf count. Aliased off the root key so the
 * count never lands under a real column (which would show it in that column
 * on group rows).
 */
export const GROUP_COUNT_ALIAS = 'group_count'

/** Returns grouped column ids without the leaf sentinel (for display or query payload). */
export function withoutLeafSentinel(columns: string[]): string[] {
  return columns.filter((id) => id !== LEAF_LEVEL_SENTINEL)
}
